import React from "react";
import LeadSourceFilter from "../../Components/Filters/LeadSourceFilter";
import { RetailCharts } from "./LeadSourceStatices/RetailCharts";
import { TableCombined } from "./LeadSourceStatices/TableCombined";

const LeadSource = () => {
  return (
    <div className="p-2">
      <div className="">
        <LeadSourceFilter />
      </div>
      <section className="p-2 px-0">
        <RetailCharts />
      </section>
      <section className="px-0 ">
        <TableCombined />
      </section>
    </div>
  );
};

export default LeadSource;
